import React from "react";

export const Features = (props) => {
  return (
    <div id="features">
      <div className="container">
        <div className="section-title">
          <h2>O QUE FAZ UMA SOFTWARE COMPANY</h2>
          <h1>Da descoberta ao desenvolvimento do seu software:</h1>
        </div>
        <div className="row">
          {props.data
            ? props.data.map((d, i) => (
                <div key={`${d.title}-${i}`} className="col-xs-12 col-md-4">
                  {" "}
                  <i className={d.icon}></i>
                  <h3>{d.title}</h3>
                  <p>{d.text}</p>
                </div>
              ))
            : "Loading..."}
        </div>
      </div>
    </div>
  );
};
